import React, { Component } from "react";

import BackWithSearch from "../../Elements/BackWithSearch";
import ContentLoader from "react-content-loader";

import { Link } from "react-router-dom";
import Icon from '../../../helpers/icon';
import { Helmet } from "react-helmet";
import axios from "axios";
import StarRatings from 'react-star-ratings';
import ReactStars from "react-rating-stars-component";

class RestaurantInfo extends Component {
	state = {
		withLinkToRestaurant: false,
		distance_to_c: 0,
		coupons: []
	};

	componentDidMount() {
		this.setState({ withLinkToRestaurant: this.props.withLinkToRestaurant });

		if (this.props.history.location.state && this.props.history.location.state.fromExplorePage) {
			this.setState({ withLinkToRestaurant: this.props.history.location.state.fromExplorePage });
		}
		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));

		axios
			.post('https://pykin.in/public/api/distance-to-customer', {
				'slug': this.props.slug,
				latitude: userSetAddress.lat,
				longitude: userSetAddress.lng,
			})
			.then((response) => {
				const distance = response.data.distance;
				const coupons = response.data.coupons;


				this.setState({ distance_to_c: distance });
				this.setState({ coupons: coupons });


			});
		this.registerScrollEvent();
	}

	componentWillUnmount() {
		this.removeScrollEvent();
	}

	fixedRestaurantInfo = (hidden) => {
		if (this.child) {
			if (hidden) {
				this.child.heading.classList.add("hidden");
			} else {
				this.child.heading.classList.remove("hidden");
			}
		}
	};

	registerScrollEvent() {
		window.addEventListener("scroll", this.scrollFunc);
	}
	removeScrollEvent() {
		window.removeEventListener("scroll", this.scrollFunc);
	}
	scrollFunc = () => {
		if (document.documentElement.scrollTop > 55) {
			let hidden = false;
			this.fixedRestaurantInfo(hidden);
		}
		if (document.documentElement.scrollTop < 55) {
			let hidden = true;
			this.fixedRestaurantInfo(hidden);
		}
	};
	render() {
		const { history, restaurant } = this.props;
		localStorage.setItem("font-css", "* { font-family: 'Poppins', sans-serif; }")

		return (
			<React.Fragment>
				<Helmet>
					<style type="text/css">{localStorage.getItem("font-css")}</style>
				</Helmet>
				{/* <div className="height-25 bg-white">
					<BackWithSearch
						ref={(node) => {
							this.child = node;
						}}
						history={history}
						boxshadow={false}
						has_restaurant_info={true}
						restaurant={restaurant}
						disable_search={true}
						homeButton={true}
					/>

					{restaurant.length === 0 ? (
						<ContentLoader
							height={170}
							width={400}
							speed={1.2}
							primaryColor="#f3f3f3"
							secondaryColor="#ecebeb"
						>
							<rect x="20" y="70" rx="4" ry="4" width="80" height="78" />
							<rect x="144" y="85" rx="0" ry="0" width="115" height="18" />
							<rect x="144" y="115" rx="0" ry="0" width="165" height="16" />
						</ContentLoader>
					) : (
						<React.Fragment>
							<Link
								to={"../../stores/" + restaurant.slug}
								className={this.state.withLinkToRestaurant ? "" : "no-click"}
							>
								<div className="pt-50">
									<div className="block-content block-content-full pt-2">
										<img
											src={localStorage.getItem('cdn')+restaurant.image}
											alt={restaurant.name}
											className="restaurant-image mt-0"
										/>
									</div>
									<div className="block-content block-content-full restaurant-info">
										<h4 className="font-w600 mb-5 text-dark">{restaurant.name}</h4>
										<div className="font-size-sm text-muted truncate-text text-muted">
											{restaurant.description}
										</div>
										{restaurant.is_pureveg === 1 && (
											<p className="mb-0">
												<span className="font-size-sm pr-1 text-muted">
													{localStorage.getItem("pureVegText")}
												</span>
												<img
													src="/assets/img/various/pure-veg.png"
													alt="PureVeg"
													style={{ width: "20px" }}
												/>
											</p>
										)}
										<div className="text-center restaurant-meta mt-5 d-flex align-items-center justify-content-between text-muted">
											<div className="col-2 p-0 text-left">
												<i
													className="fa fa-star"
													style={{
														color: localStorage.getItem("storeColor"),
													}}
												/>{" "}
												{restaurant.rating}
											</div>
											<div className="col-4 p-0 text-center">
												<i className="si si-clock" /> {restaurant.delivery_time}{" "}
												{localStorage.getItem("homePageMinsText")}
											</div>
											<div className="col-6 p-0 text-center">
												<i className="si si-wallet" />{" "}
												{localStorage.getItem("currencySymbolAlign") === "left" && (
													<React.Fragment>
														{localStorage.getItem("currencyFormat")}
														{restaurant.price_range}{" "}
													</React.Fragment>
												)}
												{localStorage.getItem("currencySymbolAlign") === "right" && (
													<React.Fragment>
														{restaurant.price_range}
														{localStorage.getItem("currencyFormat")}{" "}
													</React.Fragment>
												)}
												{localStorage.getItem("homePageForTwoText")}
											</div>
										</div>
									</div>
								</div>
							</Link>
						</React.Fragment>
					)}
				</div> */}

				<div style={{
					backgroundColor: '#ffff',
				}} className="p-4">
					<div className="d-flex " style={{ justifyContent: 'space-between', marginBottom: '4%' }}>
						<Link to={'/'}> <Icon icon="arrow-left" /> </Link>
						<div>
							<Link to={'/'}><Icon icon="home" /></Link>
						</div>

					</div>
				</div>

				<div className={'d-flex px-4'}>
					<div style={{ width: '80%' }}>
						<div className="d-flex">
							<div style={{ width: '80%' }}>
								<span style={{ "fontSize": "16px", "color": "#161616", "fontWeight": "600" }}>{restaurant.name}</span> <br /> <span className="text-muted" style={{ "fontWeight": "400", "fontSize": "12px" }}>{restaurant.description}</span>
							</div>
							<div></div>
						</div>
						<Link to={'/reviews/' + restaurant.slug} className="" style={{ alignItems: 'center', justifyContent: 'space-between'}}>
							<div style={{width:'100%' }}>{restaurant.address}</div>

							<ReactStars
								count={5}
								value={restaurant.rating}
								size={20}
								edit={false}
								isHalf={true}
								activeColor="#ffd700"
							/>
						</Link>
					</div>
					<div style={{ width: '20%' }}>
						<img alt={restaurant.name + '| Pykin'} src={localStorage.getItem('cdn') + restaurant.image} style={{ "width": "70px", "height": "70px", "borderRadius": "10px" }} />
					</div>
				</div>

				<div className="px-4">
					<hr style={{ borderTop: 'dotted 1px' }} />
					<div className="d-flex justify-content-between">
						<div style={{ "width": "33.33%", "textAlign": "center", "fontWeight": "600", "fontSize": "16px", "lineHeight": "15px" }}>{restaurant.delivery_time} mins <br /> <span style={{ "fontFamily": "Poppins", "fontStyle": "normal", "fontWeight": "normal", "fontSize": "10px", "lineHeight": "15px", "textAlign": "center" }}>Delivery Time</span> </div>
						<div style={{ "width": "33.33%", "textAlign": "center", "fontWeight": "600", "fontSize": "16px", "lineHeight": "15px" }}>{this.state.distance_to_c} km <br /> <span style={{ "fontFamily": "Poppins", "fontStyle": "normal", "fontWeight": "normal", "fontSize": "10px", "lineHeight": "15px", "textAlign": "center" }}>Distance</span></div>
						<div style={{ "width": "33.33%", "textAlign": "center", "fontWeight": "600", "fontSize": "16px", "lineHeight": "15px" }}>₹{restaurant.price_range}<br /> <span style={{ "fontFamily": "Poppins", "fontStyle": "normal", "fontWeight": "normal", "fontSize": "10px", "lineHeight": "15px", "textAlign": "center" }}>For two</span></div>
					</div>
					<hr style={{ borderTop: 'dotted 1px' }} />

				</div>
				{this.state.coupons && this.state.coupons.length > 0 &&
					<div className="scroll-items-parent">
						{this.state.coupons.map((item, index) => (
							item.is_active === 1 && (
								<div className="scroll-item" style={{ "width": "183px", "border": "0.8px solid rgba(196, 196, 196, 0.5)", "boxSizing": "border-box", "filter": "drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 8px)", "borderRadius": "5px", "padding": "6px" }}>

									<div >
										<div className="d-flex">
											<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path fill-rule="evenodd" clip-rule="evenodd" d="M6.95333 17.2782C6.85499 17.3343 6.73807 17.348 6.62945 17.3161C6.52083 17.2842 6.42987 17.2094 6.3775 17.1091L5.28083 15.0041L2.93166 14.8707C2.81922 14.8644 2.71413 14.8128 2.64034 14.7277C2.56655 14.6426 2.53036 14.5313 2.54 14.4191L2.74416 12.0466L0.837496 10.6499C0.74713 10.5838 0.687194 10.484 0.671203 10.3732C0.655212 10.2623 0.684512 10.1497 0.752496 10.0607L2.19416 8.17575L1.33583 5.95741C1.29534 5.85263 1.29888 5.73595 1.34563 5.63381C1.39239 5.53168 1.4784 5.45274 1.58416 5.41491L3.80166 4.61825L4.2675 2.28491C4.28938 2.17392 4.35545 2.0766 4.45054 2.01531C4.54562 1.95402 4.66154 1.93402 4.77166 1.95991L7.06166 2.50158L8.69916 0.794912C8.77775 0.712905 8.88641 0.666534 9 0.666534C9.11358 0.666534 9.22224 0.712905 9.30083 0.794912L10.9383 2.49991L13.2283 1.95991C13.3382 1.93398 13.4539 1.95376 13.549 2.01471C13.644 2.07566 13.7102 2.17256 13.7325 2.28325L14.1983 4.61658L16.4158 5.41408C16.5214 5.45192 16.6072 5.53072 16.654 5.63266C16.7007 5.73459 16.7044 5.85107 16.6642 5.95575L15.8058 8.17491L17.2475 10.0599C17.3155 10.1489 17.3448 10.2615 17.3288 10.3724C17.3128 10.4832 17.2529 10.5829 17.1625 10.6491L15.2558 12.0457L15.46 14.4182C15.4696 14.5305 15.4334 14.6418 15.3597 14.7269C15.2859 14.812 15.1808 14.8636 15.0683 14.8699L12.7192 15.0032L11.6225 17.1082C11.5701 17.2086 11.4792 17.2833 11.3705 17.3153C11.2619 17.3472 11.145 17.3335 11.0467 17.2774L9 16.1074L6.95333 17.2782ZM10.745 5.84074C10.8316 5.71957 10.9763 5.65382 11.1246 5.66826C11.2728 5.68271 11.4021 5.77515 11.4638 5.91076C11.5254 6.04638 11.51 6.20457 11.4233 6.32574L7.25666 12.1591C7.12273 12.3464 6.86231 12.3897 6.67499 12.2557C6.48767 12.1218 6.44439 11.8614 6.57832 11.6741L10.745 5.84074ZM6.5 6.49994V7.33328H7.33333V6.49994H6.5ZM6.5 5.66665H7.33333C7.79357 5.66665 8.16666 6.03974 8.16666 6.49998V7.33331C8.16666 7.79355 7.79357 8.16665 7.33333 8.16665H6.5C6.03976 8.16665 5.66666 7.79355 5.66666 7.33331V6.49998C5.66666 6.03974 6.03976 5.66665 6.5 5.66665ZM10.6667 10.6666V11.4999H11.5V10.6666H10.6667ZM10.6667 9.83329H11.5C11.9602 9.83329 12.3333 10.2064 12.3333 10.6666V11.5C12.3333 11.9602 11.9602 12.3333 11.5 12.3333H10.6667C10.2064 12.3333 9.83333 11.9602 9.83333 11.5V10.6666C9.83333 10.2064 10.2064 9.83329 10.6667 9.83329Z" fill="#E94E18" />
											</svg>
											<div style={{ marginLeft: '5px' }}>{item.name}</div>
										</div>
										<div style={{ "fontStyle": "normal", "fontWeight": "normal", "fontSize": "12px", "lineHeight": "18px", "color": "#7B7777" }}>
											{item.description}
										</div>
									</div>
								</div>
							)))}
					</div>
				}

				{restaurant.custom_message !== "<p><br></p>" &&
					restaurant.custom_message !== "null" &&
					(restaurant.custom_message !== "" && (
						<div
							style={{
								position: "relative",
								background: "#fff",
							}}
							dangerouslySetInnerHTML={{
								__html: restaurant.custom_message,
							}}
						/>
					))}
			</React.Fragment>
		);
	}
}

export default RestaurantInfo;
